import { render, staticRenderFns } from "./menu_manage.vue?vue&type=template&id=788de02a&scoped=true"
import script from "./menu_manage.vue?vue&type=script&lang=js"
export * from "./menu_manage.vue?vue&type=script&lang=js"
import style0 from "./menu_manage.vue?vue&type=style&index=0&id=788de02a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788de02a",
  null
  
)

export default component.exports